const constValues = {
  corporateUrl: 'https://www.run-edge.com/',
}

export default constValues
